import { IAjaxConfig } from '../helpers';
export class EnumApiPersonalCenter {
  /**
   * 移动端保存常用菜单顺序
   * @type {IAjaxConfig}
   * @memberof EnumApiIdass
   */
  readonly mobile_save_menu_sort: IAjaxConfig = {
    url: '/api/gateway/org-idaas-aggr/user/common/menu/save',
    method: 'post',
  };

  /**
   * 移动端获取常用菜单顺序
   * @type {IAjaxConfig}
   * @memberof EnumApiIdass
   */
  readonly mobile_get_menu_sort: IAjaxConfig = {
    url: '/api/gateway/org-idaas-aggr/user/common/menu/get',
    method: 'get',
    loading: true,
    immediatlyCloseLoading: true,
  };

  /**
   * @dec 获取待办
   */
  readonly syncTask_component_schedule_findByToken: IAjaxConfig = {
    url: '/api/gateway/sync-task/component/schedule/findByToken',
    method: 'get',
    loading: false,
  };

  /**
   * @dec 获取待办详情
   */
  readonly syncTask_component_schedule_get_by_id: IAjaxConfig = {
    url: '/api/gateway/sync-task/component/schedule/get/{id}',
    method: 'get',
    loading: false,
  };

  /**
   * @dec 获取数据看板相关布局(在pc端此接口为获取布局json)
   */
  readonly sitResource_get_layout_findByToken: IAjaxConfig = {
    url: '/api/gateway/site-resource/portal/layout/findByToken',
    method: 'get',
    loading: false,
  };

  /**
   * @dec 获取销售看板数据 - 组件
   */
  readonly workbench_banner_dealer_component: IAjaxConfig = {
    url: '/api/bpportal/pscd-bpp-channel-workbench-svc/component/agency/banner/data',
    method: 'post',
    loading: false,
  };

  /**
   * @dec 获取 banner销售看板数据 - 组件
   */
  readonly workbench_banner_sales_component: IAjaxConfig = {
    url: '/api/bpportal/pscd-bpp-channel-workbench-svc/component/sales/banner/data',
    method: 'post',
    loading: false,
  };

  /**
   * @dec 获取 banner商机看板数据 - 组件
   */
  readonly workbench_banner_bus_component: IAjaxConfig = {
    url: '/api/bpportal/pscd-bpp-channel-workbench-svc/component/bus/banner/data',
    method: 'post',
    loading: false,
  };

  /**
   * @dec 获取 banner销售奖励看板数据（新版）- 组件
   */
  readonly workbench_reward_quarter_banner_component: IAjaxConfig = {
    url: '/api/bpportal/pscd-bpp-channel-workbench-svc/component/sign/award/banner/data',
    method: 'get',
    loading: false,
  };
}
